import { JourneyStatus, TripStatus } from "../../proxy/enums";
import { NurseryLocation } from "./nursery-location";
import { ShipmentReportTray } from "./shipment-report-tray";
import { ShipmentTray } from "./shipment-tray";
import { Deposit } from "./deposit";
import { TripJourneyDto } from "src/app/proxy/dto";

export class TripJourney {
    id: string;
    tripId?: string;
    origin: NurseryLocation;
    originId: number;
    firstJourney: boolean;
    destination: NurseryLocation;
    destinationId: number;
    loadingTime?: string;
    hasShippingReport: boolean;
    trays: ShipmentTray[];
    reportTrays: ShipmentReportTray[];
    created?: string;
    status?: JourneyStatus;
    tripStatus?: TripStatus;
    comments?: string;
    receptionUserId: number;
    receptionUserName?: string;
    initialKms: number;
    finalKms: number;
    estimatedTime?: string;
    declaredEstimatedTime?: string;
    deposits: Deposit[];
    receptionUserVId?: string;
    shouldPickUpTrays: boolean;
    journeyOrder: number;
    traveledArcgisKilometers: number;
    journeyTripTime: number;
    journeyLimitLoadDateTime?: string;
    journeyDepartureDateTime?: string;
    journeyArrivalDateTime?: string;
    journeyUnloadingDateTime?: string;
    gpsArcgisKilometers: number;

    constructor(dto: TripJourneyDto) {
      Object.assign(this, dto);
      this.trays = dto.trays?.map(t => new ShipmentTray(t)) || [];
      this.reportTrays = dto.reportTrays?.map(r => new ShipmentReportTray(r)) || [];
    }
  }